var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"results-ready-page"},[_c('ResultsReadyPageContent'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }